import { combineReducers } from '@reduxjs/toolkit';
import login from './slices/login';
import upload from './slices/upload';

const allReducers = combineReducers({ 
    login:login,
    upload:upload
});
const rootReducer = (state, action) => {
    return allReducers(state, action);
}
export default rootReducer;